import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { SpotlightTarget } from '@atlaskit/onboarding';
import Button, { ButtonGroup } from '@atlaskit/button';
import PageHeader from '@atlaskit/page-header';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';

// @source
import { RouteLink } from '../../../components';

const Header = ({ onSpotlightOpen }) => (
  <PageHeader
    actions={(
      <ButtonGroup>
        <SpotlightTarget name="user-promotion">
          <Button
            iconBefore={<QuestionCircleIcon size="small" />}
            appearance="subtle"
            onClick={onSpotlightOpen}
          />
        </SpotlightTarget>
        <SpotlightTarget name="create-user">
          <Button
            appearance="primary"
            component={RouteLink}
            href="/users/create"
          >
            Create user
          </Button>
        </SpotlightTarget>
      </ButtonGroup>
    )}
    bottomBar={
      <p>Please adjust the settings for users.</p>
    }
  >
    All user accounts.
  </PageHeader>
);

Header.propTypes = {
  onSpotlightOpen: PropTypes.func.isRequired,
};

export default Header;
